import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-country-picker-modal',
  templateUrl: './country-picker-modal.component.html',
  styleUrls: ['./country-picker-modal.component.scss'],
})
export class CountryPickerModalComponent {
  @Input() countries: { code: string; name: string }[] = [];
  @Input() selectedCode: string = '';

  constructor(private modalCtrl: ModalController) {}

  select(code: string) {
    this.modalCtrl.dismiss({ code });
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
